const AppPharmacy = () => import('./pharmacy.vue');
const PharmacyManagement = () => import('./pharmacy-management/pharmacy-management.vue');
const IvPreparation = () => import('./iv-preparation/iv-preparation.vue');
const IvOrders = () => import('./iv-orders/iv-orders.vue');
const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'
export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}
const pharmacyRoutes = [
    {
        path: '/pharmacy',
        name: 'app.Pharmacy',
        meta: {
           // title: this.$i18n.t('Nav.Pharmacy.Pharmacy'),
            title: translation[lang].Nav.Pharmacy.Pharmacy,
        },
        component: AppPharmacy,
        children: [
            {
                path: 'pharmacy-management',
                name: '/pharmacy/pharmacy-management',
                component: PharmacyManagement,
                meta: {
                   // title: this.$i18n.t('Nav.Pharmacy.Pharmacy'),
                    title: translation[lang].Nav.Pharmacy.PharmacyManagement,
                    clickable: true
                },
            },
            {
                path: 'iv-preparation',
                name: '/pharmacy/IV-Preparation',
                component: IvPreparation,
                meta: {
                    // title: this.$i18n.t('Nav.Pharmacy.Pharmacy'),
                    title: translation[lang].Nav.Pharmacy.IVPreparation,
                    clickable: true
                },
            },
            {
                path: 'iv-orders',
                name: '/pharmacy/IV-orders',
                component: IvOrders,
                meta: {
                    title: translation[lang].Nav.Pharmacy.IVorders,
                    clickable: true
                },
            },
        ]
    }

]

export default pharmacyRoutes;
